export default "__VITE_ASSET__DMJjNqUH__"